import logger from '~/services/logger';

const defaultVideoType = 'application/x-mpegURL';

export const getVideoType = (src?: string) => {
  if (src) {
    try {
      const parsedURL = new URL(src);
      const pathname = parsedURL?.pathname;

      const types: Record<string, string> = {
        aac: 'audio/aac',
        gif: 'image/gif',
        jpeg: 'image/jpeg',
        jpg: 'image/jpeg',
        m3u8: 'application/x-mpegURL',
        m4a: 'audio/mp4',
        m4v: 'video/mp4',
        mkv: 'video/x-matroska',
        mov: 'video/mp4',
        mp3: 'audio/mpeg',
        mp4: 'video/mp4',
        mpd: 'application/dash+xml',
        oga: 'audio/ogg',
        ogv: 'video/ogg',
        opus: 'video/ogg',
        png: 'image/png',
        svg: 'image/svg+xml',
        webp: 'image/webp',
      };

      const extension =
        (pathname || '.m3u8').split('.').pop()?.toLowerCase() || 'm3u8';

      const type = types[extension] || defaultVideoType;

      return type;
    } catch (error) {
      logger.info(`failed to get video type: ${error}`);

      return defaultVideoType;
    }
  }

  return defaultVideoType;
};
